import { useMemo } from "react";

import type { FilterDefinition } from "@/ds";
import type { PermissionOption } from "./use-permission-options";
import { ROLES_PERMISSION_FILTER_KEY, ROLES_PERMISSION_FILTER_LABEL } from "../roles.constants";

interface UseRolesFiltrosParams {
  readonly options: PermissionOption[];
  readonly isLoading: boolean;
  readonly hasError: boolean;
}

/** Filtro de Permissões por multisseleção (HU 722), inline no topo da tabela (Figma 4434:110769). */
export function useRolesFiltros({
  options,
  isLoading,
  hasError,
}: UseRolesFiltrosParams): FilterDefinition[] {
  return useMemo<FilterDefinition[]>(
    () => [
      {
        key: ROLES_PERMISSION_FILTER_KEY,
        label: ROLES_PERMISSION_FILTER_LABEL,
        type: "multiselect",
        options,
        isLoading,
        hasError,
        searchPlaceholder: "Buscar permissão",
      },
    ],
    [options, isLoading, hasError],
  );
}
